export default (response) => {
  const error = new Error('Request rejected');
  error.config = response.config;
  error.request = response.request;
  error.response = response;
  return error;
};
